<template>
  <div
    id="b-info"
    class="fullheight info-wrapper"
    :style="bInfoStyle"
    v-if="currentBuilding"
  >
    <button
      type="button"
      class="close close-btn"
      data-dismiss="alert"
      aria-label="Close"
      @click="onClose"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <h3
      id="e-title"
      :style="titleStyle"
      @click="onTitleClick"
    >
      <span class="glyphicon glyphicon-play"></span>{{ currentBuilding.title }}
    </h3>
    <h4
      id="e-location"
      title="Увеличить на карте"
      class="prob-01"
      @click="onAddressClick"
    >
      <span class="glyphicon glyphicon-play"></span>
      <span id="e-address" :style="{ color: bgColor }">{{
        currentBuilding.address
      }}</span>
    </h4>
    <h5 id="e-status">
      <template v-if="currentBuilding.status">{{ currentBuilding.status }}<br /></template>{{ problemType }}
    </h5>
    <div id="b-images">
      <building-image
        v-for="(image, index) in images"
        :image-src="imageOriginalPath(image, currentBuilding.id)"
        :image-tumbnail="imageXsPath(image, currentBuilding.id)"
        :height="148"
        :group-name="`building-${currentBuilding.id}`"
        :key="index"
      ></building-image>
    </div>
    <p class="e-updated">Обновлено: {{ currentBuilding.updated_at }}</p>
    <div id="e-description">
      <div
        v-for="(block, index) in descriptionBlocks"
        :key="index"
        class="description-blocks"
      >
        {{ block }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lightbox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.min.css';
import BuildingImage from '@/components/BuildingImage.vue';
import { imageOriginalPath, imageXsPath } from '@/utils/imagePath';

export default {
  name: 'BuildingInfo',
  components: {
    BuildingImage,
  },

  data() {
    return {
      isVisible: true,
      bInfoStyle: {},
    };
  },

  computed: {
    ...mapGetters(['currentBuilding', 'problems', 'eventBus', 'isMobile']),
    problem() {
      return this.problems.filter(
        (p) => p.id === this.currentBuilding.problemId
      )[0];
    },
    galleryLink() {
      return `/read/${this.currentBuilding.id}`;
    },
    bgColor() {
      return this.problem.color;
    },
    problemType() {
      if (this.problem.id === 5 || this.problem.id === 6) {
        if (this.problem.id === 5) {
          return 'В черной книге';
        } else {
          return 'Сохранено';
        }
      } else {
        return `Тип угрозы: ${this.problem.title}`;
      }
    },
    titleStyle() {
      return {
        color: this.bgColor,
        width: this.isMobile ? '100%' : '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
      };
    },
    images() {
      return this.currentBuilding.images.slice(0, 2);
    },
    descriptionBlocks() {
      return this.currentBuilding.description.split('\n');
    },
  },

  watch: {
    '$route.params.id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.isVisible = true;
        }
      },
    },
  },

  methods: {
    imageOriginalPath,
    imageXsPath,
    onTitleClick() {
      if (!this.isMobile) {
        this.$router.push(this.galleryLink);
      }
    },
    onAddressClick() {
      const zoom = 17;
      const { lat, lng } = this.currentBuilding;
      this.eventBus.$emit('center-and-zoom-location', {
        zoom,
        lat,
        lng,
      });
      this.isVisible = false;
      if (this.isMobile) {
        const style = {
          position: 'absolute',
          top: 0,
          'z-index': 10000000,
          'background-color': '#fff',
        };
        style.left = `${this.isVisible ? 0 : -window.innerWidth}px`;
        this.bInfoStyle = style;
      }
    },
    onClose() {
      this.isVisible = false;
      console.log('this.isVisible close', this.isVisible);
      if (this.isMobile) {
        const style = {
          position: 'absolute',
          top: 0,
          'z-index': 10000000,
          'background-color': '#fff',
        };
        style.left = `${this.isVisible ? 0 : -window.innerWidth}px`;
        this.bInfoStyle = style;
      }
    },
  },

  mounted() {
    lightbox.option({
      resizeDuration: 200,
      wrapAround: true,
    });
    this.eventBus.$on('marker-click', () => {
      this.isVisible = true;
      if (this.isMobile) {
        const style = {
          position: 'absolute',
          top: 0,
          'z-index': 10000000,
          'background-color': '#fff',
        };
        style.left = `${this.isVisible ? 0 : -window.innerWidth}px`;
        this.bInfoStyle = style;
      }
    });
    this.$nextTick(() => {
      if (this.isMobile) {
        const style = {
          position: 'absolute',
          top: 0,
          'z-index': 10000000,
          'background-color': '#fff',
        };
        style.left = `${this.isVisible ? 0 : -window.innerWidth}px`;
        this.bInfoStyle = style;
      }
    });
  },
};
</script>

<style>
.glyphicon-play {
  color: #d2232a;
  font-weight: 700;
}

@media (min-width: 390px) {
  button.close-btn {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

@media (max-width: 390px) {
  button.close-btn {
    display: block;
  }
}
</style>
